import React, { useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, H2, Reviews, ReviewRating, Modal, InlineTextButton } from '../../components';

import css from './ListingPage.module.css';

const SectionReviews = props => {
  const { reviews, fetchReviewsError, onManageDisableScrolling } = props;
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);

  const ratingAvg =
    reviews.length > 0
      ? (
          reviews.reduce((sum, review) => sum + review.attributes.rating, 0) / reviews.length
        ).toFixed(1)
      : '0.0';

  return (
    <section className={css.sectionReviews}>
      <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
        <FormattedMessage id="ListingPage.reviewsTitle" values={{ count: reviews.length }} />
      </Heading>
      {fetchReviewsError ? (
        <H2 className={css.errorText}>
          <FormattedMessage id="ListingPage.reviewsError" />
        </H2>
      ) : null}
      <div className={css.reviewDiv}>
        <span className={css.rating}>{ratingAvg}</span>
        <ReviewRating
          rating={parseFloat(ratingAvg)}
          className={css.desktopReviewRating}
          reviewStarClassName={css.reviewRatingStar}
        />
        <span className={css.reviews}>
          <FormattedMessage
            id="ListingPage.reviews"
            values={{
              count: reviews.length,
              b: chunks => <span className={css.chunks}>{chunks}</span>,
            }}
          />
        </span>
      </div>
      <InlineTextButton
        onClick={() => setIsReviewModalOpen(true)}
        className={css.seeAllBtn}
        disabled={reviews.length === 0}
      >
        <FormattedMessage id="ListingPage.seeAllReviews" />
      </InlineTextButton>
      <Modal
        id="SectionReviews.reviewsModal"
        isOpen={isReviewModalOpen}
        onClose={() => setIsReviewModalOpen(false)}
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <H2 className={css.reviewHeading}>
          <FormattedMessage id="ListingPage.reviewHeading" />
        </H2>
        <Reviews reviews={reviews} />
      </Modal>
    </section>
  );
};

export default SectionReviews;
